import * as yup from "yup";
import { isValidMonthYear } from "../helpers/funnelHelpers";

const hoje = new Date();
hoje.setHours(0, 0, 0, 0);

const volumeSchema = yup
  .number()
  .nullable()
  .transform((value, originalValue) => {
    return isNaN(originalValue) ||  originalValue === '' ? null : value
  }
  )
  .when('semConsumo', {
    is: true,
    then: (schema) => schema.min(0),
    otherwise: (schema) =>
      schema
        .required('Campo obrigatório')
        .moreThan(0, 'O valor deve ser maior que zero'),
  });

export const itemSchema = yup.object({
  funilObraGrupoProdutoId: yup
    .number()
    .required("Selecione o grupo de produto")
    .moreThan(0, "Selecione o grupo de produto"),

  funilObraUnidadeMedidaId: yup
    .number()
    .required("Selecione a unidade de medida")
    .moreThan(0, "Selecione a unidade de medida"),

  dataNegociacao: yup
    .string()
    .required("Selecione a data de negociação")
    .transform((value) => value.split('-')?.reverse()?.join('/'))
    .test("valid-month-year", "Data inválida", value => {
      return isValidMonthYear(value);
    })
    .test("min-month-year", "A data deve ser atual ou futura", value => {
      if (!value || !isValidMonthYear(value)) return false;

      const [month, year] = value.split("/").map(Number);

      const currentMonth = hoje.getMonth() + 1;
      const currentYear = hoje.getFullYear();

      return (
        year > currentYear ||
        (year === currentYear && month >= currentMonth)
      );
    }),

  volumeMapeado: volumeSchema,

  volumeNegociado: volumeSchema
});

const createVolumeSchema = (
  requiredIds,
  message
) =>
  yup
    .number()
    .nullable()
    .transform((value, originalValue) =>
      isNaN(originalValue) || originalValue === "" ? null : value
    )
    .when("semConsumo", {
      is: true,
      then: (schema) => schema.min(0),
      otherwise: (schema) =>
        schema.when("funilObraGrupoProdutoId", ([grupoId], schema) => {
          return requiredIds.includes(Number(grupoId))
            ? schema
                .required("Campo obrigatório")
                .moreThan(0, message)
            : schema.nullable();
        }),
    });

export const createItemSchema = (requiredIds) => {
  return yup.object({
    funilObraGrupoProdutoId: yup
      .number()
      .required()
      .moreThan(0),

    dataNegociacao: yup
      .string()
      .transform((value) =>
        value ? value.split("-").reverse().join("/") : value
      )
      .when("funilObraGrupoProdutoId", ([grupoId], schema) => {
        const isRequired = requiredIds.includes(Number(grupoId));

        if (isRequired) {
          schema = schema.required("Selecione a data de negociação");
        } else {
          schema = schema.notRequired();
        }

        return schema
          .test("valid-month-year", "Data inválida", value => {
            if (!value) return !isRequired;
            return isValidMonthYear(value);
          })
          .test("min-month-year", "A data deve ser atual ou futura", value => {
            if (!value) return !isRequired;

            if (!isValidMonthYear(value)) return false;

            const [month, year] = value.split("/").map(Number);

            const currentMonth = hoje.getMonth() + 1;
            const currentYear = hoje.getFullYear();

            return (
              year > currentYear ||
              (year === currentYear && month >= currentMonth)
            );
          });
      }),

    volumeMapeado: createVolumeSchema(
      requiredIds,
      "O volume mapeado deve ser maior do que zero"
    ),

    volumeNegociado: createVolumeSchema(
      requiredIds,
      "O volume negociado deve ser maior do que zero"
    ),
  });
};

export const useFunnelNewGroupSchema = () => itemSchema;
export const createItemSchemaArray = (requiredIds) => 
  yup.array().of(createItemSchema(requiredIds));
